import styled, { css, keyframes } from 'styled-components';
export var SLIDING_DURATION = 250;
var slideIn = function slideIn(windowHeight) {
  return keyframes(["from{height:", "px;}to{height:", "px;}"], windowHeight + 140, windowHeight);
};
var slideOut = function slideOut(windowHeight) {
  return keyframes(["from{height:", "px;}to{height:", "px;}"], windowHeight, windowHeight + 140);
};
export var Sliding = styled.div.withConfig({
  displayName: "animation__Sliding",
  componentId: "sc-iy2qhs-0"
})(["position:relative;width:100%;", ""], function (_ref) {
  var state = _ref.state,
    windowHeight = _ref.windowHeight;
  switch (state) {
    case 'entering':
      return css(["animation:", " ease-in ", "ms;"], slideIn(windowHeight), SLIDING_DURATION);
    case 'entered':
      return css(["height:", "px;"], windowHeight);
    case 'exiting':
      return css(["animation:", " ease-out ", "ms;"], slideOut(windowHeight), SLIDING_DURATION);
    case 'exited':
      return css(["height:", "px;"], windowHeight + 140);
  }
});